import { Lexer } from "../text/lexer/Lexer";
import { LexerMatcher } from "../text/lexer/LexerMatcher";
import { LexerMatcherLibrary } from "../text/lexer/LexerMatcherLibrary";

export class RJLexer extends Lexer
{
  static readonly BracketOpen = "(";
  static readonly BracketClose = ")";

  static readonly OperatorMatcher:LexerMatcher = LexerMatcherLibrary.OPERATOR_MATCHER;
  static readonly FunctionMatcher:LexerMatcher = LexerMatcherLibrary.CFUNCTION_MATCHER;
  static readonly WordMatcher:LexerMatcher = LexerMatcherLibrary.CWORD_MATCHER;
   
  constructor()
  {
    super();

    this.addAllMatchers( 
      LexerMatcherLibrary.SINGLE_LINE_COMMENT_MATCHER,
      LexerMatcherLibrary.MULTI_LINE_COMMENT_MATCHER,
      LexerMatcherLibrary.DOUBLE_QUOTED_STRING_MATCHER,
      LexerMatcherLibrary.SINGLE_QUOTED_STRING_MATCHER,
      LexerMatcherLibrary.NUMBER_MATCHER,
      LexerMatcherLibrary.NULL_MATCHER,
      LexerMatcherLibrary.BOOL_MATCHER,
      LexerMatcherLibrary.BREAK_MATCHER,
      LexerMatcherLibrary.WHITESPACE_MATCHER,
      LexerMatcherLibrary.LOGIC_MATCHER,
      LexerMatcherLibrary.BRACKET_MATCHER,
      LexerMatcherLibrary.OPERATOR_MATCHER,
      LexerMatcherLibrary.CFUNCTION_MATCHER,
      LexerMatcherLibrary.CWORD_MATCHER,
      LexerMatcherLibrary.ANY_SYMBOL_MATCHER
    );

  }
}